// src/pages/PendingActions/components/StatsCard.js
import React from 'react';
import { Card } from 'react-bootstrap';

const StatsCard = ({ icon, iconColor, value, label }) => {
  const getIconColorClass = (color) => {
    const colorMap = {
      warning: 'bg-warning-subtle text-warning',
      danger: 'bg-danger-subtle text-danger',
      info: 'bg-info-subtle text-info',
      success: 'bg-success-subtle text-success',
      pink: 'bg-pink-subtle text-pink',
      primary: 'bg-primary-subtle text-primary'
    };
    return colorMap[color] || colorMap.primary;
  };

  return (
    <Card className="stat-card h-100">
      <Card.Body>
        <div className="d-flex align-items-center gap-3 mb-2">
        <div className={`stat-icon ${getIconColorClass(iconColor)} mt-4`}>
          {icon}
        </div>
        <div className="stat-value">{value}</div>
    </div>
        <div className="stat-label">{label}</div>
      </Card.Body>
    </Card>
  );
};

export default StatsCard;